/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { useTranslations } from "@i18n/react";

import { spacing } from "../../../../../../global/emotion";
import type { CardProps } from "../../../../refactor/Card/Card.emotion";
import { Card } from "../../../../refactor/Card/Card.emotion";
import type { TriviaScoreProps } from "../TriviaScore/TriviaScore.emotion";
import { TriviaScore } from "../TriviaScore/TriviaScore.emotion";

const cardStyle: Interpolation = {
  paddingBottom: "96px",
  paddingTop: `calc(${spacing.full} - ${spacing.xs})`,
};
const imgContainerStyle: Interpolation<{
  color: TriviaMediumProps["color"];
}> = (props) => ({
  alignItems: "center",
  backgroundColor: props.color,
  display: "flex",
  justifyContent: "center",
});
const infoContainerStyle: Interpolation = {
  paddingLeft: spacing.m,
  paddingRight: spacing.m,
};
const maskStyle: Interpolation = {
  paddingLeft: spacing.m,
  paddingRight: spacing.m,
};
const triviaScoreStyle: Interpolation = {
  paddingBottom: spacing.m,
  paddingLeft: spacing.m,
  paddingRight: spacing.m,
};

export type TriviaMediumProps = CardProps &
  Pick<TriviaScoreProps, "questions" | "summary">;

export const TriviaMedium = ({
  centerActions,
  color,
  description,
  imgContainerCSS = {},
  imgSrc,
  infoContainerCSS = {},
  maskProps,
  questions,
  summary,
  title,
  ...props
}: TriviaMediumProps) => {
  const t = useTranslations();
  return (
    <Card
      centerActions={questions && summary ? null : centerActions}
      color={color}
      description={description ?? t("trivia_sub_title")}
      imgContainerProps={{
        children:
          questions && summary ? (
            <TriviaScore
              color={color}
              questions={questions}
              summary={summary}
              css={triviaScoreStyle}
            />
          ) : null,
      }}
      imgContainerCSS={[imgContainerStyle({ color }), imgContainerCSS]}
      imgSrc={questions && summary ? null : imgSrc}
      infoContainerCSS={[infoContainerStyle, infoContainerCSS]}
      maskCSS={maskStyle}
      maskProps={maskProps}
      rightActions={questions && summary ? centerActions : null}
      title={title ?? t("trivia_section_title")}
      css={cardStyle}
      {...props}
    />
  );
};
